<div class="container" id="tabla" style="background-color: white; padding-top: 0px; padding-bottom:0px;">
    <div class="row">
        <div class="col-12">
            <mat-card style="padding: 12px;">
                <mat-tab-group mat-stretch-tabs="false" class="demo-tab-group">
                    <mat-tab label="Datos Laborales">
                        <div class="demo-tab-content" style="overflow: hidden;">
                            <br>
                            <div class="row">
                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Rut</mat-label>
                                        <input type="text" autocomplete="off" matInput required [disabled]="isDisabled"
                                            id="rut" name="rut" #rutFuncionario
                                            (focusout)="focusOutRutFuncionario(rutFuncionario.value)" placeholder="Rut"
                                            [(ngModel)]="this.rutBuscado"
                                            toUppercase />
                                        <mat-icon matPrefix class="op-5">badge</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Estado</mat-label>
                                        <input type="text" style="text-align: left;" autocomplete="off" matInput
                                            readonly id="estadoFuncionario" name="estadoFuncionario"
                                            [(ngModel)]="this.funcionario.estadoFuncionario" toUppercase
                                            placeholder="Estado" />
                                        <mat-icon matPrefix class="op-5" [ngStyle]="{
                                                                                        color: funcionario.estadoFuncionario === 'CESADO' ? 'red' :
                                                                                            (funcionario.estadoFuncionario === 'ACTIVO' ? 'green' :
                                                                                            (funcionario.estadoFuncionario ? 'orange' : 'inherit'))
                                                                                    }">verified_user
                                        </mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Código</mat-label>
                                        <input type="text" style="text-align: center;" autocomplete="off" matInput
                                            readonly id="numeroEmpleado" name="numeroEmpleado"
                                            [(ngModel)]="this.funcionario.numeroEmpleado"
                                            placeholder="Código" />
                                        <mat-icon matPrefix class="op-5">code</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Nombre</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="nombreCompleto"
                                            name="nombreCompleto" [(ngModel)]="this.funcionario.nombreCompleto"
                                            placeholder="Nombre" />
                                        <mat-icon matPrefix class="op-5">person</mat-icon>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-9">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Unidad</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="unidad"
                                            name="unidad" [(ngModel)]="this.funcionario.unidad" toUppercase
                                            placeholder="Unidad" />
                                        <mat-icon matPrefix class="op-5">school</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Tipo contrato</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="tipoContrato"
                                            name="tipoContrato" [(ngModel)]="this.funcionario.tipoContrato" toUppercase
                                            placeholder="Tipo contrato" />
                                        <mat-icon matPrefix class="op-5">work</mat-icon>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-lg-6">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Cargo</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="cargo" name="cargo"
                                            [(ngModel)]="this.funcionario.cargo" toUppercase placeholder="Cargo" />
                                        <mat-icon matPrefix class="op-5">work</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Fecha Inicio Cargo</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="fechaInicioCargo"
                                            name="fechaInicioCargo" [(ngModel)]="this.funcionario.fechaInicioCargo"
                                            toUppercase placeholder="Fecha Inicio Cargo" />
                                        <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Estamento</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="estamento"
                                            name="estamento" [(ngModel)]="this.funcionario.estamento" toUppercase
                                            placeholder="Estamento" />
                                        <mat-icon matPrefix class="op-5">work</mat-icon>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Fecha Ingreso</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="fechaIngreso"
                                            name="fechaIngreso" [(ngModel)]="this.funcionario.fechaIngreso" toUppercase
                                            placeholder="Fecha Ingreso" />
                                        <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div *ngIf="this.funcionario.estadoFuncionario == 'CESADO'" class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Fecha Cese</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="fechaCese"
                                            name="fechaCese" [(ngModel)]="this.funcionario.fechaCese" toUppercase
                                            placeholder="Fecha Cese" />
                                        <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Grado</mat-label>
                                        <input type="text" style="text-align: center;" autocomplete="off" matInput
                                            readonly id="grado" name="grado" [(ngModel)]="this.funcionario.grado"
                                            toUppercase placeholder="Grado" />
                                        <mat-icon matPrefix class="op-5">grade</mat-icon>
                                    </mat-form-field>
                                </div>

                                <div class="col-lg-2">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Bienios</mat-label>
                                        <input type="text" style="text-align: center;" autocomplete="off" matInput
                                            readonly id="cantidadBienios" name="cantidadBienios"
                                            [(ngModel)]="this.funcionario.cantidadBienios" toUppercase
                                            placeholder="Bienios" />
                                        <mat-icon matPrefix class="op-5">numbers</mat-icon>
                                    </mat-form-field>
                                </div>
                                
                                
                            </div>
                            <div class="row">
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Nombre Isapre</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="nombreIsapre"
                                            name="nombreIsapre" [(ngModel)]="this.funcionario.nombreIsapre" toUppercase
                                            placeholder="Nombre Isapre" />
                                        <mat-icon matPrefix class="op-5">account_balance</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Nombre AFP</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly id="nombreAfp"
                                            name="nombreAfp" [(ngModel)]="this.funcionario.nombreAfp" toUppercase
                                            placeholder="Nombre AFP" />
                                        <mat-icon matPrefix class="op-5">account_balance</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Caja Compensación</mat-label>
                                        <input type="text" autocomplete="off" matInput readonly
                                            id="nombreCajaCompensacion" name="nombreCajaCompensacion"
                                            [(ngModel)]="this.funcionario.nombreCajaCompensacion" toUppercase
                                            placeholder="Caja Compensación" />
                                        <mat-icon matPrefix class="op-5">account_balance</mat-icon>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Saldo PCGR</mat-label>
                                        <input type="text" style="text-align: center;" autocomplete="off" matInput
                                            readonly id="perSaldoPcgr" name="perSaldoPcgr"
                                            [(ngModel)]="this.funcionario.perSaldoPcgr" toUppercase
                                            placeholder="Saldo PCGR" />
                                        <mat-icon matPrefix class="op-5">more_time</mat-icon>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                                        <mat-label>Saldo Feriado Legal</mat-label>
                                        <input type="text" style="text-align: center;" autocomplete="off" matInput
                                            readonly id="perSaldoFeriadoLegal" name="perSaldoFeriadoLegal"
                                            [(ngModel)]="this.funcionario.perSaldoFeriadoLegal" toUppercase
                                            placeholder="Saldo Feriado Legal" />
                                        <mat-icon matPrefix class="op-5">more_time</mat-icon>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Liquidaciones y Certificados">
                        <div class="demo-tab-content" style="overflow: hidden; padding-top: 24px;">
                            <mat-card class="cardWithShadow theme-card">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-lg-3">
                                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                                <mat-label>Año</mat-label>
                                                <mat-select [(value)]="selectedYearLiquidacion"
                                                    (selectionChange)="onYearChange()" [disabled]="disableLiquidacion || this.groupedDataLiquidacion.length == 0">
                                                    <mat-option *ngFor="let year of groupedDataLiquidacion"
                                                        [value]="year.anio">
                                                        {{ year.anio }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-3">
                                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                                <mat-label>Mes</mat-label>
                                                <mat-select [(value)]="selectedMonthLiquidacion"
                                                    [disabled]="disableLiquidacion || this.groupedDataLiquidacion.length == 0">
                                                    <mat-option *ngFor="let month of filteredMonths"
                                                        [value]="month.mes">
                                                        {{ monthNames[month.mes] }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-2">
                                            <button mat-flat-button (click)="getLiquidacion()" color="accent"
                                                class="m-l-8"
                                                [disabled]="disableLiquidacion || this.groupedDataLiquidacion.length == 0">
                                                <mat-icon matPrefix class="op-5">download</mat-icon>
                                                Liquidación
                                            </button>
                                        </div>
                                        <div *ngIf="this.groupedDataLiquidacion.length == 0 && this.encontroFuncionario" class="col-lg-3 d-flex"
                                            style="align-items: center; justify-content: left;">
                                            <label>No se encontraron liquidaciones</label>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="cardWithShadow theme-card">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-lg-3">
                                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                                <mat-label>Meses</mat-label>
                                                <mat-select [(value)]="selectedMes"
                                                    [disabled]="disableLiquidacion || this.groupedDataLiquidacion.length == 0">
                                                    <mat-option [value]='6'> 6 Meses </mat-option>
                                                    <mat-option [value]='12'> 12 Meses </mat-option>
                                                </mat-select>
                                                <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-2">
                                            <button mat-flat-button (click)="doCertificadoSueldo()" color="accent"
                                                class="m-l-8"
                                                [disabled]="disableLiquidacion || this.groupedDataLiquidacion.length == 0">
                                                <mat-icon matPrefix class="op-5">download</mat-icon>
                                                Certificado Sueldo
                                            </button>
                                        </div>
                                        <div *ngIf="this.groupedDataLiquidacion.length == 0 && this.encontroFuncionario" class="col-lg-4 d-flex"
                                            style="align-items: center; justify-content: left;">
                                            <label>No se encontraron liquidaciones</label>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="cardWithShadow theme-card">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-lg-3">
                                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                                <mat-label>Año</mat-label>
                                                <mat-select [(value)]="selectedYearCertificadoRenta"
                                                    [disabled]="this.aniosCertificadoRentas.length == 0">
                                                    <mat-option *ngFor="let yearCR of aniosCertificadoRentas"
                                                        [value]="yearCR">
                                                        {{ yearCR }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-icon matPrefix class="op-5">calendar_month</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-lg-2">
                                            <button mat-flat-button (click)="doCertificadoRenta()" color="accent"
                                                class="m-l-8" [disabled]="this.aniosCertificadoRentas.length == 0">
                                                <mat-icon matPrefix class="op-5">download</mat-icon>
                                                Certificado Renta
                                            </button>
                                        </div>
                                        <div *ngIf="this.aniosCertificadoRentas.length == 0 && this.encontroFuncionario" class="col-lg-3 d-flex"
                                                style="align-items: center; justify-content: left;">
                                                <label>No se encontraron certificados de renta.</label>
                                            </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="cardWithShadow theme-card">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-lg-3">
                                            <button mat-flat-button (click)="doCertificadoAntiguedad()" color="accent"
                                                class="m-l-8" [disabled]="disableAntiguedad">
                                                <mat-icon matPrefix class="op-5">download</mat-icon>
                                                Certificado Antigüedad
                                            </button>
                                        </div>
                                        <div *ngIf="disableAntiguedad && this.encontroFuncionario" class="col-lg-4 d-flex" style="align-items: center; justify-content: left;">
                                            <label>No tiene fecha de ingreso a JUNJI ó sin fecha de inicio cargo.</label>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </mat-tab>
                    <mat-tab label="Licencias Médicas">
                        <div class="demo-tab-content" style="overflow: hidden; padding-top: 24px;">
                            <mat-card class="cardWithShadow">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row d-flex justify-content-right align-items-center"
                                        style="padding-top: 10px;">
                                        <div class="col-md-4 d-flex">
                                            <mat-form-field appearance="outline" class="w-200 hide-hint">
                                                <mat-label>Buscar</mat-label>
                                                <input [disabled]="this.licencia.length == 0" matInput
                                                    [(ngModel)]="filterValue" toUppercase (keyup)="applyFilter()" />
                                                <mat-icon matPrefix class="op-5">search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2 d-flex ">
                                            <mat-form-field appearance="outline" class="w-100 hide-hint">
                                                <mat-label>Filtro columna</mat-label>
                                                <mat-select [disabled]="this.licencia.length == 0" id="selectedColumn"
                                                    name="selectedColumn" [(ngModel)]="selectedColumn"
                                                    (selectionChange)="applyFilter()">
                                                    <mat-option value="todas">TODAS</mat-option>
                                                    <mat-option *ngFor="let filtro of filtros" value="{{filtro.value}}">
                                                        {{filtro.text}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-icon matPrefix class="op-5">filter_list</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2 d-flex">
                                            <button mat-flat-button (click)="exportToExcel()"
                                                [disabled]="this.licencia.length == 0" color="primary"
                                                class="w-100 hide-hint">
                                                <mat-icon matPrefix class="op-5">import_export</mat-icon>
                                                Exportar
                                            </button>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="cardWithShadow">
                                <mat-card-content class="p-5">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="dataLicencias" class="w-100 hide-hint" matSort
                                            #sort="matSort" (matSortChange)="announceSortChange($event)">

                                            <ng-container matColumnDef="folio">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Folio</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;"
                                                    class="f-s-11">
                                                    {{ element.folio }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="tipoLicencia">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Tipo Licencia</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;"
                                                    class="f-s-11">{{ element.tipoLicencia }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="fechaInicio">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Fecha Inicio</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11">{{ element.fechaInicio }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="fechaTermino">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Fecha Término</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11">{{ element.fechaTermino }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="dias">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Días</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.dias }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="estado">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Estado</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.estado }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="salud">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Salud</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.salud }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="numeroResolucion">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Número Resolución</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.numeroResolucion }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="fechaResolucion">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600" mat-sort-header>Fecha Resolución</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.fechaResolucion }} </td>
                                            </ng-container>

                                            <!-- <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef class="f-s-11">Acciones</th>
                                            <td mat-cell *matCellDef="let element" style="text-align: center;" class="action-link">
                                                <mat-icon
                                                #tooltip="matTooltip"
                                                matTooltip= "Editar"
                                                matTooltipPosition="above"
                                                color="primary" 
                                                matPrefix 
                                                class="m-r-10 cursor-pointer">edit</mat-icon>
                                            </td>
                                        </ng-container> -->

                                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                        </table>
                                        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[8, 16, 24]"
                                            showFirstLastButtons>
                                        </mat-paginator>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </mat-tab>
                    <!-- <mat-tab label="Cargas Familiares">
                        <div class="demo-tab-content" style="overflow: hidden; padding-top: 24px;">
                            <mat-card class="cardWithShadow">
                                <mat-card-content class="b-t-1 p-5">
                                    <div class="row d-flex justify-content-right align-items-center" style="padding-top: 10px;">
                                        <div class="col-md-2 d-flex">
                                            <button mat-flat-button (click)="exportToExcelCargasFamiliares()"
                                                [disabled]="this.cargaFamiliar.length == 0" color="primary"
                                                class="w-100 hide-hint">
                                                <mat-icon matPrefix class="op-5">import_export</mat-icon>
                                                Exportar
                                            </button>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="cardWithShadow">
                                <mat-card-content class="p-5">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="dataCargasFamiliares" class="w-100 hide-hint">

                                            <ng-container matColumnDef="tipo_Beneficio">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Tipo Beneficio</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11">
                                                    {{ element.tipo_Beneficio }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="afecto_a_Pago">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Afecto a Pago</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11">{{ element.afecto_a_Pago }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="valor">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Valor</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11">{{ element.valor }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="nombre">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Nombre</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;"
                                                    class="f-s-11">{{ element.nombre }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="rut">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Rut</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: right;"
                                                    class="f-s-11"> {{ element.rut }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="causante">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Causante</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;"
                                                    class="f-s-11"> {{ element.causante }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="fecha_reconocimiento_formal">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Fecha Reconocimiento</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.fecha_reconocimiento_formal }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="fecha_termino">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Fecha Término</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.fecha_termino }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="fecha_extincion">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Fecha Extinción</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.fecha_extincion }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="motivo_extincion">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Motivo Extinción</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: left;"
                                                    class="f-s-11"> {{ element.motivo_extincion }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="estado">
                                                <th mat-header-cell *matHeaderCellDef style="text-align: center;"
                                                    class="f-s-14 f-w-600">Estado</th>
                                                <td mat-cell *matCellDef="let element" style="text-align: center;"
                                                    class="f-s-11"> {{ element.estado }} </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsCF"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsCF"></tr>
                                        </table>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </mat-tab> -->
                </mat-tab-group>
            </mat-card>
        </div>
    </div>
</div>